import { getUser, setStoreExperience } from '@utsubo/experience'
import { getURLRoot } from './global'

export async function saveEmote(workspace, microverse, emoteName) {
  const { user } = getUser()
  if (!user) return
  const idToken = await user.getIdToken()
  const resp = await fetch(`/api/save-emote`, {
    method: 'POST',
    body: JSON.stringify({
      emoteName,
      workspace,
      microverse,
    }),

    headers: {
      authorization: `Bearer ${idToken}`,
    },
  })
}
